import * as React from "react";

const Accordian2 = ({ color = "#80FF00" }) => (
  <svg width={326} height={42} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.67.605h310.541v22.962l-13.274 17.828H0v-26.87L14.67.606Z"
      fill="#070707"
    />
    <path
      d="M228.733.798h96.285v22.705L311.84 41.202H.193V14.61L14.747.798H228.733Z"
      stroke={color}
      strokeWidth={0.386}
    />
  </svg>
);

export default Accordian2;
